import { c as _c } from "react/compiler-runtime";
import { SvgBadgeDiscount, SvgChatQuestion, SvgEvent, SvgFileTextHeart, SvgNotice, SvgReceiptText, SvgReferral, SvgStarTag } from '@common/icon';
import { usePathname } from 'next/navigation';
import { useShallow } from 'zustand/react/shallow';
import { DONATION_ROUTES, ROUTES, SUB_DOMAIN } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { openResponsiveDialog } from '@/stores/DrawerStore';
import { JejuCertificateContent } from '../(private)/my/(benefit)/jeju/(certificate)/_components/JejuCertificateContent';
interface NavigationItem {
  label: string;
  href: string;
  icon: React.ReactElement;
  isLoginRequired: boolean;
  isNew?: boolean;
  onClick?: () => void;
}
interface NavigationGroup {
  label: string;
  items: NavigationItem[];
}
export const useNavigationGroupList = () => {
  const $ = _c(27);
  const isLogin = useAuthStore(_temp) ?? false;
  const router = useCustomRouter();
  const pathname = usePathname();
  const [isToss, isKbPay] = useDeviceInfoStore(useShallow(_temp2));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SvgFileTextHeart className="size-20" originalFill={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let NAVIGATION_GROUP_LIST;
  let t1;
  let t2;
  let t3;
  if ($[1] !== isKbPay || $[2] !== isLogin || $[3] !== isToss || $[4] !== pathname || $[5] !== router) {
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <SvgFileTextHeart className="size-20" originalFill={true} />;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <SvgReceiptText className="size-20" originalFill={true} />;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <SvgFileTextHeart className="size-20" originalFill={true} />;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== isLogin || $[14] !== pathname || $[15] !== router) {
      t7 = isTossOrKbPay => ({
        label: "\uB098\uC758 \uD61C\uD0DD",
        items: [{
          label: "\uD0D0\uB098\uB294 \uC81C\uC8FC\uD328\uC2A4",
          href: "#",
          onClick: () => {
            if (!isLogin) {
              return router.push(ROUTES.LOGIN.withSearchParams({
                searchParams: {
                  redirect: pathname || ""
                }
              }));
            }
            openResponsiveDialog({
              component: JejuCertificateContent,
              drawerType: "bottom"
            });
          },
          icon: <SvgBadgeDiscount className="size-20" originalFill={true} />,
          isLoginRequired: true,
          isNew: false
        }, ...(isTossOrKbPay ? [] : [{
          label: "\uCE5C\uAD6C \uCD08\uB300 \uD604\uD669",
          href: DONATION_ROUTES.MY_INVITE.pathname,
          icon: <SvgReferral className="size-20" originalFill={true} />,
          isLoginRequired: true,
          isNew: true
        }]), {
          label: "\uC6F0\uD3EC\uC778\uD2B8 \uC0C1\uC810",
          href: ROUTES.POINT_MARKET.pathname,
          icon: <SvgEvent className="size-20" originalFill={true} />,
          isLoginRequired: true,
          isNew: true,
          onClick: () => {
            if (!isLogin) {
              return router.push(ROUTES.LOGIN.withSearchParams({
                searchParams: {
                  redirect: pathname || ""
                }
              }));
            }
            router.push(ROUTES.POINT_MARKET.pathname);
          }
        }]
      });
      $[13] = isLogin;
      $[14] = pathname;
      $[15] = router;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <SvgChatQuestion className="size-20" originalFill={true} />;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <SvgStarTag className="size-20" originalFill={true} />;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <SvgNotice className="size-20" originalFill={true} />;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <SvgEvent className="size-20" originalFill={true} />;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    NAVIGATION_GROUP_LIST = {
      MY_DONATIONS: {
        label: "\uB098\uC758 \uAE30\uBD80",
        items: [{
          label: "\uAE30\uBD80\uB0B4\uC5ED",
          href: DONATION_ROUTES.MY_DONATIONS.pathname,
          icon: t0,
          isLoginRequired: true,
          isNew: false
        }]
      },
      MY_GIFTS: {
        label: "\uB098\uC758 \uB2F5\uB840\uD488",
        items: [{
          label: "\uC7A5\uBC14\uAD6C\uB2C8",
          href: DONATION_ROUTES.CART.pathname,
          icon: t4,
          isLoginRequired: true,
          isNew: false
        }, {
          label: "\uC8FC\uBB38 \xB7 \uBC30\uC1A1 \uB0B4\uC5ED",
          href: ROUTES.MY_ORDERS.pathname,
          icon: t5,
          isLoginRequired: true,
          isNew: false
        }, {
          label: "\uBC30\uC1A1\uC9C0 \uAD00\uB9AC",
          href: ROUTES.MY_DELIVERY_ADDRESS.pathname,
          icon: t6,
          isLoginRequired: true,
          isNew: false
        }]
      },
      MY_BENEFITS: t7,
      MY_ACTIVITIES: {
        label: "\uB098\uC758 \uD65C\uB3D9",
        items: [{
          label: "\uBB38\uC758 \uB0B4\uC5ED",
          href: DONATION_ROUTES.MY_INQUIRY_HISTORY.pathname,
          icon: t8,
          isLoginRequired: true
        }, {
          label: "\uB2F5\uB840\uD488 \uD6C4\uAE30",
          href: ROUTES.MY_REVIEWS.pathname,
          icon: t9,
          isLoginRequired: true,
          isNew: false
        }]
      },
      INFO_GUIDE: {
        label: "\uC548\uB0B4",
        items: [{
          label: "\uACF5\uC9C0\uC0AC\uD56D",
          href: DONATION_ROUTES.MY_ETC_NOTICE.pathname,
          icon: t10,
          isLoginRequired: false,
          isNew: false
        }, {
          label: "\uC774\uBCA4\uD2B8",
          href: DONATION_ROUTES.MY_ETC_EVENT.pathname,
          icon: t11,
          isLoginRequired: false,
          isNew: false
        }]
      }
    };
    t1 = NAVIGATION_GROUP_LIST.MY_DONATIONS;
    t2 = NAVIGATION_GROUP_LIST.MY_GIFTS;
    t3 = NAVIGATION_GROUP_LIST.MY_BENEFITS(isToss || isKbPay);
    $[1] = isKbPay;
    $[2] = isLogin;
    $[3] = isToss;
    $[4] = pathname;
    $[5] = router;
    $[6] = NAVIGATION_GROUP_LIST;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    NAVIGATION_GROUP_LIST = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
  }
  let t4;
  if ($[21] !== NAVIGATION_GROUP_LIST.INFO_GUIDE || $[22] !== NAVIGATION_GROUP_LIST.MY_ACTIVITIES || $[23] !== t1 || $[24] !== t2 || $[25] !== t3) {
    const DEFAULT_NAVIGATION_GROUP_LIST = [t1, t2, t3, NAVIGATION_GROUP_LIST.MY_ACTIVITIES, NAVIGATION_GROUP_LIST.INFO_GUIDE];
    t4 = {
      navigationGroupList: DEFAULT_NAVIGATION_GROUP_LIST
    };
    $[21] = NAVIGATION_GROUP_LIST.INFO_GUIDE;
    $[22] = NAVIGATION_GROUP_LIST.MY_ACTIVITIES;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  return t4;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(state_0) {
  return [state_0.subDomain === SUB_DOMAIN.TOSS, state_0.subDomain === SUB_DOMAIN.KB_PAY] as const;
}